import { useTranslation } from "react-i18next";
import "../css/LanguageSwitcher.css";

type Props = {
  variant?: "inline" | "floating";
};

const languageOptions = [
  { value: "en", label: "English" },
  { value: "ro", label: "Romana" },
  { value: "tr", label: "Turkce" },
  { value: "it", label: "Italiano" },
  { value: "is", label: "Islenska" }
] as const;

export default function LanguageSwitcher({ variant = "inline" }: Props) {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage || i18n.language || "en";

  return (
    <label className={`languageSwitcher languageSwitcher--${variant}`}>
      <span className="languageSwitcher-label">{t("common.language")}</span>
      <select
        className="languageSwitcher-select"
        value={currentLanguage}
        onChange={(event) => void i18n.changeLanguage(event.target.value)}
        aria-label={t("common.language")}
      >
        {languageOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
